import { render, staticRenderFns } from "./_base-header.vue?vue&type=template&id=5d9d1fcc&"
import script from "./_base-header.vue?vue&type=script&lang=js&"
export * from "./_base-header.vue?vue&type=script&lang=js&"
import style0 from "./_base-header.vue?vue&type=style&index=0&id=5d9d1fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports